import {
  AwningViewNoteType,
  ExteriorWindowCasingViewNoteType,
  ShutterViewNoteTypes,
  WindowViewNoteType,
  ExteriorDoorCasingViewNoteType,
  DoorViewNoteType,
  ExteriorTrimViewNoteType,
  PorchTrimViewNoteType,
} from "building-types/settings/viewNotesSettings";
import type { ViewNote } from "building-types/views/viewNotes";
import type { Table, RWTable } from "common/data/table";

export const WindowAggregateViewNoteKeys = [
  ...Object.keys(AwningViewNoteType),
  ...Object.keys(ExteriorWindowCasingViewNoteType),
  ...Object.keys(ShutterViewNoteTypes),
  ...Object.keys(WindowViewNoteType),
];

export const DoorAggregateViewNoteKeys = [
  ...Object.keys(AwningViewNoteType),
  ...Object.keys(ExteriorDoorCasingViewNoteType),
  ...Object.keys(DoorViewNoteType),
];

export const DoorDescriptorAggregateViewNoteKeys = [
  ...Object.keys(ExteriorDoorCasingViewNoteType),
  ...Object.keys(DoorViewNoteType),
];

export const ExteriorTrimAggregateViewNoteKeys = [
  ...Object.keys(ExteriorTrimViewNoteType),
  ...Object.keys(PorchTrimViewNoteType),
];

export function mergeViewNoteTables(...tables: (Table<ViewNote> | undefined)[]): Table<ViewNote> {
  const mergedTables: RWTable<ViewNote> = {};
  for (const table of tables) {
    for (const key in table) {
      mergedTables[key] = { ...mergedTables[key], ...table[key] };
    }
  }
  return mergedTables;
}
